import { orderDetailsButtonSetStyles as styles } from "@iewccouk/Overrides/Widgets/OrderDetails/OrderDetailsButtonSet";

delete styles.rmaButton?.buttonType;
styles.rmaButton = {
    variant: "tertiary",
};

styles.changeOrderButton = {
    variant: "tertiary",
};
